import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from '@chakra-ui/react';
import { useContext } from 'react';
import { theme } from '../../modules/theme';
import { IconStatus } from '../IconStatus';
import { Context } from './context';
export const ToastIcon = forwardRef((props, ref) => {
    const { status } = useContext(Context);
    return _jsx(IconStatus, { ref: ref, status: status, size: theme.sizes['6'], ...props });
});
